import React from "react";
import "./Faq_Accordian.css";
import { Accordion } from "react-bootstrap";

function Faq_Accordian() {
  return (
    <>
      <section className="Faq_Accordian">
        <div className="accordian-div">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                What can I use a personal loan for and what types of personal loans do personal
                loan finance companies offer with different personal loan interest rates?
              </Accordion.Header>
              <Accordion.Body>
                Personal loans provide flexible funding for debt consolidation, home improvements,
                medical bills, vacations, or weddings without collateral requirements. Personal loan
                finance companies offer various types of personal loans including personal business
                loans, long term personal loans, and short-term financing, each with personalized
                loans featuring competitive personal loan interest rates based on your credit and
                specific financial needs.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                How do personal loan companies calculate personal loan eligibility and personal
                loan interest rates?
              </Accordion.Header>
              <Accordion.Body>
                Personal loan companies assess personal loan eligibility using your credit score,
                income, employment status, and debt-to-income ratio. These factors determine your
                personal loan interest rates and personal loan finance terms based on your
                repayment ability.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Are Personal Loans Taxable in India? Do personal loan rates impact tax obligations
                on personal loans?
              </Accordion.Header>
              <Accordion.Body>
                No, personal loans are not taxable in India as they're borrowed funds, not income.
                Personal loan rates don't affect tax obligations since the loan amount isn't taxed. The
                best personal loans maintain this tax-neutral status, though any investment returns
                from loan proceeds may be taxable.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                What are the other charges associated with a personal loan?
              </Accordion.Header>
              <Accordion.Body>
                Besides interest, a personal loan may have a one-time processing fee. Your loan
                agreement will specify any relevant prepayment or late payment fees.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                What are long term personal loans and which personal loan finance company
                offers the best rates?
              </Accordion.Header>
              <Accordion.Body>
                Long term personal loans extend repayment periods beyond 5 years, offering lower
                monthly payments. Personal loan organizations provide these extended terms, often
                with personal loans with low interest rates for qualified borrowers.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                Do personal loan organizations provide personal business loans with fast loan
                approval?
              </Accordion.Header>
              <Accordion.Body>
                Yes, many personal loan finance companies specialize in personal business loans
                with streamlined fast loan approval processes. These personal loan finance solutions
                help entrepreneurs access capital quickly for business needs.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                What documentation speeds up fast loan approval for personal business loans?
              </Accordion.Header>
              <Accordion.Body>
                Personal loan finance companies require business registration, financial statements,
                and personal credit history for personal business loans. Having complete
                documentation ready accelerates fast loan approval from personal loan
                organizations.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>
                What makes certain personal loan organizations better for personal loan finance
                needs?
              </Accordion.Header>
              <Accordion.Body>
                Top personal loan finance companies combine fast loan approval, competitive rates,
                flexible types of personal loans, and excellent customer service. Look for personal
                loan organizations with transparent terms and strong digital platforms.
              </Accordion.Body>
            </Accordion.Item>

       

            <Accordion.Item eventKey="8">
              <Accordion.Header>
                What are the key characteristics that differentiate types of personal loans offered
                by personal loan finance companies?
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>Personal Business Loan: Higher loan amounts with business documents required.</li>
                  <li>Long Term Personal Loans: Extended repayment periods with lower monthly payments.</li>
                  <li>Secured Personal Loans: Lower rates requiring collateral</li>
                  <li>Unsecured Personal Loans: No collateral needed with higher interest rates</li>
                  <li>Low Interest Rate Personal Loans: Extended repayment periods with lower monthly payments.</li>
                </ul>
                <p>Personal loan organizations design these different types to meet varying borrower
                  needs.</p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9">
              <Accordion.Header>
                How does a personal loan affect my credit score and credit report?
              </Accordion.Header>
              <Accordion.Body>

                <p>Personal loans impact your credit through hard inquiries during application and
                  monthly payment history. Timely payments improve your credit score, while missed
                  payments from personal loan finance companies negatively affect your credit report.</p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </section>
    </>
  );
}

export default Faq_Accordian;
